export enum AdvertiserModalMode {
  CLIENT = 'client',
  AGENCY = 'agency',
}
